export const DoneIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_8031_17499" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7254 4.27458C17.0915 4.64071 17.0915 5.2343 16.7254 5.60042L7.81917 14.5067C7.45305 14.8728 6.85946 14.8728 6.49334 14.5067L2.27458 10.2879C1.90847 9.92182 1.90847 9.3282 2.27458 8.9621C2.64071 8.59601 3.2343 8.59601 3.60042 8.9621L7.15626 12.518L15.3996 4.27458C15.7657 3.90847 16.3593 3.90847 16.7254 4.27458Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7254 4.27458C17.0915 4.64071 17.0915 5.2343 16.7254 5.60042L7.81917 14.5067C7.45305 14.8728 6.85946 14.8728 6.49334 14.5067L2.27458 10.2879C1.90847 9.92182 1.90847 9.3282 2.27458 8.9621C2.64071 8.59601 3.2343 8.59601 3.60042 8.9621L7.15626 12.518L15.3996 4.27458C15.7657 3.90847 16.3593 3.90847 16.7254 4.27458Z"
        fill="white"
      />
    </svg>
  );
};
